import { render, staticRenderFns } from "./ListaRecepcionistasUnidade.vue?vue&type=template&id=3f03d0c8&scoped=true"
import script from "./ListaRecepcionistasUnidade.vue?vue&type=script&lang=js"
export * from "./ListaRecepcionistasUnidade.vue?vue&type=script&lang=js"
import style0 from "./ListaRecepcionistasUnidade.vue?vue&type=style&index=0&id=3f03d0c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f03d0c8",
  null
  
)

export default component.exports